import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { http } from "../../lib/http";
import { PageHeader, PageBody } from "../../components/shell/PageChrome";
import { Input } from "../../components/ui/input";
import ExportMenu from "../../components/ExportMenu";
import TablePagination from "../../components/data/TablePagination";

export default function AuditLog() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [moduleFilter, setModuleFilter] = useState("");
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const PAGE_SIZE = 50;

  const fetchLog = async () => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (moduleFilter) params.set("module", moduleFilter);
    params.set("skip", String((page - 1) * PAGE_SIZE));
    params.set("limit", String(PAGE_SIZE));
    const r = await http.get(`/admin/audit-log?${params}`);
    setItems(r.data.items);
    setTotal(r.data.total);
  };

  useEffect(() => { fetchLog(); /* eslint-disable-line react-hooks/exhaustive-deps */ }, [q, moduleFilter, page]);
  useEffect(() => { setPage(1); }, [q, moduleFilter]);

  return (
    <div data-testid="audit-log-page">
      <PageHeader title={t("audit.title")} subtitle={t("audit.subtitle")} />
      <PageBody>
        <div className="mb-4 flex items-center gap-3">
          <Input placeholder={t("common.search")} value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs bg-white" data-testid="audit-search" />
          <Input placeholder="Module (e.g. gdpr, backups)" value={moduleFilter} onChange={(e)=>setModuleFilter(e.target.value)} className="max-w-xs bg-white" data-testid="audit-module-filter"/>
          <div className="ml-auto flex items-center gap-3">
            <span className="text-xs text-slate-500">Total: {total}</span>
            <ExportMenu resource="audit-log" extraParams={{ module: moduleFilter }} filename="audit_log" testId="audit-export"/>
          </div>
        </div>
        <div className="mb-3 flex justify-end">
          <TablePagination page={page} total={total} pageSize={PAGE_SIZE} onPageChange={setPage} testid="audit-pagination-top" />
        </div>
        <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden" data-testid="audit-table">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr className="text-left">
                <th className="px-5 py-3 text-xs uppercase tracking-wider text-slate-500 font-medium">{t("audit.timestamp")}</th>
                <th className="px-5 py-3 text-xs uppercase tracking-wider text-slate-500 font-medium">{t("audit.user")}</th>
                <th className="px-5 py-3 text-xs uppercase tracking-wider text-slate-500 font-medium">{t("audit.action")}</th>
                <th className="px-5 py-3 text-xs uppercase tracking-wider text-slate-500 font-medium">{t("audit.module")}</th>
                <th className="px-5 py-3 text-xs uppercase tracking-wider text-slate-500 font-medium">{t("audit.entity")}</th>
                <th className="px-5 py-3 text-xs uppercase tracking-wider text-slate-500 font-medium">{t("audit.ip")}</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((it) => (
                <tr key={it.id} className="hover:bg-slate-50/50" data-testid={`audit-row-${it.id}`}>
                  <td className="px-5 py-3 text-slate-500 text-xs">{new Date(it.ts).toLocaleString()}</td>
                  <td className="px-5 py-3 text-[#0A1F44]">{it.user_email || "—"}</td>
                  <td className="px-5 py-3 font-mono text-xs">{it.action}</td>
                  <td className="px-5 py-3 text-slate-600">{it.module}</td>
                  <td className="px-5 py-3 text-slate-500 font-mono text-xs">{it.entity_id || "—"}</td>
                  <td className="px-5 py-3 text-slate-400 text-xs">{it.ip || "—"}</td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={6} className="px-5 py-12 text-center text-slate-400">{t("common.noResults")}</td></tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="mt-4 flex justify-end">
          <TablePagination page={page} total={total} pageSize={PAGE_SIZE} onPageChange={setPage} testid="audit-pagination-bottom" />
        </div>
      </PageBody>
    </div>
  );
}
